document.addEventListener("DOMContentLoaded", () => {
  const equaliseSquares = () => {
    // Select each distinct container that holds a group of .squared-w-icon-cont elements
    const containers = document.querySelectorAll(".squared-w-icon");

    containers.forEach((container) => {
      const squares = container.querySelectorAll(".squared-w-icon-cont");
      if (!squares.length) return;

      // Reset height to auto before measuring
      squares.forEach((el) => (el.style.height = "auto"));

      let tallest = 0;
      squares.forEach((el) => {
        const h = el.offsetHeight;
        if (h > tallest) tallest = h;
      });

      squares.forEach((el) => (el.style.height = `${tallest}px`));
    });
  };

  equaliseSquares();
  window.addEventListener("resize", equaliseSquares);
  window.addEventListener("orientationchange", equaliseSquares);

  // Attach image load listeners within each .squared-w-icon container
  document.querySelectorAll(".squared-w-icon-cont img").forEach((img) => {
    if (img.complete) return;
    img.addEventListener("load", equaliseSquares);
    img.addEventListener("error", equaliseSquares);
  });
});
